import type { ComponentProps, ReactNode } from "react";
import DemoFooter from "@/components/preview/demo-footer";
import DemoSplit from "@/components/preview/demo-split";
import DemoWrapper, {
  type DemoHeight,
} from "@/components/preview/demo-wrapper";
import ResultPanel from "@/components/preview/result-panel";

interface ComparisonProps {
  bad: ReactNode;
  footer?: ReactNode;
  good: ReactNode;
  height?: DemoHeight;
  panelClassName?: string;
  stackBelow?: ComponentProps<typeof DemoSplit>["stackBelow"];
  topBar?: ReactNode;
}

export default function Comparison({
  bad,
  footer,
  good,
  height,
  panelClassName,
  stackBelow = "sm",
  topBar,
}: ComparisonProps) {
  return (
    <DemoWrapper height={height} margin="">
      {topBar ? <DemoFooter position="top">{topBar}</DemoFooter> : null}
      <DemoSplit className="h-full" stackBelow={stackBelow}>
        <ResultPanel bad innerClassName={panelClassName}>
          {bad}
        </ResultPanel>
        <ResultPanel innerClassName={panelClassName}>{good}</ResultPanel>
      </DemoSplit>
      {footer ? <DemoFooter>{footer}</DemoFooter> : null}
    </DemoWrapper>
  );
}
